module.exports = __webpack_public_path__ + "img/full0-min.f1ff8834.png";